import { useI18n } from "../i18n";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const AuthCallback = () => {
  const { t } = useI18n();
  const done = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    api.post("/auth/session", { session_id: sid })
      .then((r) => { setUser(r.data); navigate("/", { replace: true }); })
      .catch(() => navigate("/", { replace: true }));
  }, [navigate, setUser]);

  return <div className="ghost-root flex items-center justify-center font-mono text-subtle tracking-widest" data-testid="auth-callback">{t("tuning")}</div>;
};
